/**
 * Authentication hook providing additional utilities
 * Extends the base AuthContext with additional features
 */

import { useCallback, useState } from 'react';
import { useAuthContext } from '@/contexts/use-auth-context';

export const useAuth = () => {
  const authContext = useAuthContext();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logout = useCallback(async () => {
    try {
      setIsLoggingOut(true);
      await authContext.logout();
    } finally {
      setIsLoggingOut(false);
    }
  }, [authContext]);

  return {
    ...authContext,
    logout,
    isLoggingOut,
  };
};
